import React, { useState } from 'react';
import styled from 'styled-components';
import { FileText, FolderTree, MessageSquare } from 'lucide-react';
import KnowledgeDocumentsView from './KnowledgeDocumentsView';
import KnowledgeTopicsView from './KnowledgeTopicsView';
import KnowledgeChatView from './KnowledgeChatView';

const SubTabBar = styled.div`
  display: flex;
  gap: 4px;
  padding: 4px;
  background: ${(p) => p.theme.colors.backgroundSecondary};
  border: 1px solid ${(p) => p.theme.colors.border};
  border-radius: ${(p) => p.theme.borderRadius.md};
  margin-bottom: ${(p) => p.theme.spacing.lg};
  width: fit-content;
`;

const SubTab = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: ${(p) => (p.$active ? p.theme.colors.background : 'transparent')};
  border: none;
  border-radius: ${(p) => p.theme.borderRadius.sm};
  color: ${(p) => (p.$active ? p.theme.colors.text : p.theme.colors.muted)};
  font-size: 13px;
  font-weight: ${(p) => (p.$active ? 600 : 500)};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    color: ${(p) => p.theme.colors.text};
  }
`;

export default function KnowledgeBaseTab({ organizationId, canManage, theme }) {
  const [activeView, setActiveView] = useState('documents');

  return (
    <div>
      <SubTabBar theme={theme}>
        <SubTab
          theme={theme}
          $active={activeView === 'documents'}
          onClick={() => setActiveView('documents')}
        >
          <FileText size={14} /> Documents
        </SubTab>
        <SubTab
          theme={theme}
          $active={activeView === 'topics'}
          onClick={() => setActiveView('topics')}
        >
          <FolderTree size={14} /> Topics
        </SubTab>
        <SubTab
          theme={theme}
          $active={activeView === 'chat'}
          onClick={() => setActiveView('chat')}
        >
          <MessageSquare size={14} /> Chat
        </SubTab>
      </SubTabBar>

      {activeView === 'documents' && (
        <KnowledgeDocumentsView organizationId={organizationId} canManage={canManage} theme={theme} />
      )}
      {activeView === 'topics' && (
        <KnowledgeTopicsView organizationId={organizationId} canManage={canManage} theme={theme} />
      )}
      {activeView === 'chat' && (
        <KnowledgeChatView organizationId={organizationId} theme={theme} />
      )}
    </div>
  );
}
